import React from 'react';
import { Row, Col, Statistic, Card } from 'antd';
import {
  FolderOutlined,
  UserOutlined,
  TeamOutlined,
  CalendarOutlined,
} from '@ant-design/icons';

interface CaseStatisticsProps {
  statistics: {
    total_cases: number;
    active_cases: number;
    closed_cases: number;
    suspended_cases: number;
    my_cases: number;
    as_responsible: number;
    as_assistant: number;
    this_month_new: number;
    my_this_month_new: number;
  } | null;
  loading: boolean;
  onCardClick?: (filterType: 'all' | 'responsible' | 'assistant' | 'thisMonth') => void;
  isAdmin?: boolean;
}

const CaseStatistics: React.FC<CaseStatisticsProps> = ({ 
  statistics, 
  loading,
  onCardClick,
  isAdmin = false
}) => {
  if (!statistics) return null;

  const handleCardClick = (filterType: 'all' | 'responsible' | 'assistant' | 'thisMonth') => {
    if (onCardClick) {
      onCardClick(filterType);
    }
  };

  return (
    <Row gutter={16} style={{ marginBottom: 16 }}>
      <Col xs={24} sm={12} md={6}>
        <Card 
          loading={loading}
          hoverable={isAdmin}
          onClick={isAdmin ? () => handleCardClick('all') : undefined}
          style={isAdmin ? { cursor: 'pointer' } : undefined}
        >
          <Statistic
            title="全部案件"
            value={statistics.total_cases}
            prefix={<FolderOutlined />}
            valueStyle={{ color: '#1890ff' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card 
          loading={loading}
          hoverable
          onClick={() => handleCardClick('responsible')}
          style={{ cursor: 'pointer' }}
        >
          <Statistic
            title="我负责的"
            value={statistics.as_responsible}
            prefix={<UserOutlined />}
            valueStyle={{ color: '#52c41a' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card 
          loading={loading}
          hoverable
          onClick={() => handleCardClick('assistant')}
          style={{ cursor: 'pointer' }}
        >
          <Statistic
            title="我协助的"
            value={statistics.as_assistant}
            prefix={<TeamOutlined />}
            valueStyle={{ color: '#faad14' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card loading={loading}>
          <Statistic
            title="本月新增"
            value={statistics.my_this_month_new}
            prefix={<CalendarOutlined />}
            valueStyle={{ color: '#722ed1' }}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default CaseStatistics;
